export default "__VITE_ASSET__B8mv48XQ__"